import {jsonMember, jsonObject} from "typedjson";
import {DxBaseControlOptions} from "./dx-base-control-options";

@jsonObject
export class DxInputControlOptions extends DxBaseControlOptions {

  /**
   * Возможные опции для Input'а
   *  @controlId: string - ID контрола
   *  @label: string - подпись
   *  @hint: string - всплывающая подсказка
   *  @isDisabled: boolean - поле активно/не активно
   *  @isHidden: boolean - поле спрятано/отображается
   *
   *  @placeholder: string - заполнитель
   *  @isFocused: boolean - фокус на поле ввода
   *
   * */


  /** заполнитель */
  @jsonMember({name: "placeholder", constructor: String, emitDefaultValue: false, isRequired: false})
  private _placeholder: string;

  /** фокус на поле ввода */
  @jsonMember({name: "isFocused", constructor: Boolean, emitDefaultValue: false, isRequired: false})
  private _isFocused: boolean;

  get placeholder(): string {
    return this._placeholder;
  }

  set placeholder(value: string) {
    this._placeholder = value;
  }

  get isFocused(): boolean {
    return this._isFocused;
  }

  set isFocused(value: boolean) {
    this._isFocused = value;
  }


}
